// extracted by mini-css-extract-plugin
export var audioPlayer = "_q5-0";